import { Skeleton } from '@mui/material';

const ButtonSkeleton = () => {
  return <Skeleton variant="rounded" width={120} height={36.5} />;
};

export default ButtonSkeleton;
